import AnswerDeleteModalContainer from './AnswerDeleteModalContainer';

export default AnswerDeleteModalContainer;
